import Api from "./api"

// NO DEFAULT_MAP_COLORS constant - database is single source of truth

/**
 * Fetch color ranges for a school from the API.
 * NOTE: Named "fetch*" to avoid collision with getColorRanges() in
 * map_view_data.js which builds UtilizationRange objects from data.
 *
 * @param {string} schoolId
 * @param {AbortSignal} [signal]
 * @returns {Promise<{percentage: Array, default: Array}>}
 * @throws {Error} If API returns unexpected shape
 */
export async function fetchColorRanges(schoolId, signal) {
  const response = await Api.get(`schools/${schoolId}/map/settings`, { signal })

  if (!response.data?.colorRanges) {
    throw new Error("API contract violation: response missing colorRanges")
  }

  const { colorRanges } = response.data

  // Validate percentage array exists and has expected length
  if (!Array.isArray(colorRanges.percentage) || colorRanges.percentage.length !== 5) {
    throw new Error(
      "API contract violation: colorRanges.percentage must be an array with 5 elements"
    )
  }

  return colorRanges
}

/**
 * Save map colors for a school.
 * @param {string} schoolId
 * @param {Object} colors - {inactive, low, moderate, active, high}
 * @param {AbortSignal} [signal]
 * @returns {Promise<{percentage: Array, default: Array}>}
 * @throws {Error} If API returns unexpected shape
 */
export async function saveMapColors(schoolId, colors, signal) {
  const response = await Api.put(`schools/${schoolId}/map/settings`, { colors }, { signal })

  if (!response.data?.colorRanges) {
    throw new Error("API contract violation: response missing colorRanges")
  }

  const { colorRanges } = response.data

  // Validate percentage array exists and has expected length
  if (!Array.isArray(colorRanges.percentage) || colorRanges.percentage.length !== 5) {
    throw new Error(
      "API contract violation: colorRanges.percentage must be an array with 5 elements"
    )
  }

  return colorRanges
}
